export default {
  name: 'Name',
  actions: 'Actions',
  'list.entities.name_pending': 'Pendencies Types',
  'list.entities.name_serviceTransport': 'Transport Types',
  'list.entities.name_rescheduling': 'Rescheduling Motives',
  'list.entities.name_approved': 'Approval Motives',
  'list.entities.name_disapproved': 'Disapproval Motives',
  'list.entities.name_unproductive': 'Unproductive Motives',
  'list.entities.name_canceled': 'Cancel Motives',
  'list.entities.name_pause': 'Pause Motives',
  'list.entities.name_closing': 'Closing Motives',

  title_modal_pending_edit: 'Edit Pendencies Types',
  title_modal_serviceTransport_edit: 'Edit Transport Types',
  title_modal_rescheduling_edit: 'Edit Rescheduling Motives',
  title_modal_approved_edit: 'Edit Approval Motives',
  title_modal_disapproved_edit: 'Edit Disapproval Motives',
  title_modal_unproductive_edit: 'Edit Unproductive Motives',
  title_modal_canceled_edit: 'Edit Cancel Motives',
  title_modal_checkListCategory_edit: `Edit Category`,
  title_modal_assetType_edit: `Edit Asset Type`,
  title_modal_closing_edit: `Edit Closing Motives`,

  title_modal_pending: 'New Pendencies Types',
  title_modal_serviceTransport: 'New Transport Types',
  title_modal_rescheduling: 'New Rescheduling Motives',
  title_modal_approved: 'New Approval Motives',
  title_modal_disapproved: 'New Disapproval Motives',
  title_modal_unproductive: 'New Unproductive Motives',
  title_modal_canceled: 'New Cancel Motives',
  title_modal_checkListCategory: `New Category`,
  title_modal_assetType: 'New Asset Type',
  title_modal_closing: 'New Closing Motives',
  selectCategories: 'Category selection'
}
